import { FontItem, FontFamily } from "./types";

export const WEIGHT_ORDER = [
  "Thin",
  "Light",
  "Regular",
  "Medium",
  "SemiBold",
  "Bold",
  "ExtraBold",
  "Black",
] as const;

export const sortFontVariants = (variants: FontItem[]): FontItem[] => {
  return [...variants].sort((a, b) => {
    const aIndex = WEIGHT_ORDER.indexOf((a.weight as any) || "Regular");
    const bIndex = WEIGHT_ORDER.indexOf((b.weight as any) || "Regular");
    return aIndex !== -1 && bIndex !== -1
      ? aIndex - bIndex
      : a.fullName.localeCompare(b.fullName);
  });
};

export const sortFontFamilies = (families: FontFamily[]): FontFamily[] => {
  // keep fonts with no pretty name at the end
  return [...families].sort((a, b) => {
    const isASpecial =
      a.variants.length === 1 && a.variants[0].hasName === false;
    const isBSpecial =
      b.variants.length === 1 && b.variants[0].hasName === false;

    if (isASpecial && !isBSpecial) {
      return 1; // 'a' is special, 'b' is not, so 'a' goes after 'b'
    }
    if (!isASpecial && isBSpecial) {
      return -1; // 'b' is special, 'a' is not, so 'b' goes after 'a'
    }
    return a.familyName.localeCompare(b.familyName);
  });
};
